// extracted by mini-css-extract-plugin
module.exports = {"container":"information_container__CuOfQ","title":"information_title__2o0eU","indicator":"information_indicator__LMz3S"};